const visualPalette = {
  ink: "#222325",
  muted: "#65707c",
  line: "rgba(34, 35, 37, 0.16)",
  softLine: "rgba(34, 35, 37, 0.10)",
  gold: "#c9b07b",
  goldSoft: "rgba(201, 176, 123, 0.22)",
  goldWash: "rgba(201, 176, 123, 0.10)",
  surface: "rgba(255, 255, 255, 0.68)",
};

export default visualPalette;
